<template>
  <div id="app-wrapper" :style="wrapperStyles">
    <!-- App Store Download Modal -->
    <transition name="modal-fade">
      <div v-if="showAppStoreModal && isWeb" class="modal-overlay" @click="closeAppStoreModal">
        <div class="modal-container" @click.stop>
          <button class="modal-close" @click="closeAppStoreModal">✕</button>

          <div class="modal-content">
            <div class="modal-icon">
              🎉
            </div>

            <h2 class="modal-title">全新 iOS App 現已推出！</h2>

            <p class="modal-description">
              立即下載港式台牌計番神器 App，<br>
              體驗更流暢的使用體驗！
            </p>

            <a href="https://apps.apple.com/hk/app/%E6%B8%AF%E5%BC%8F%E5%8F%B0%E7%89%8C%E8%A8%88%E7%95%AA%E7%A5%9E%E5%99%A8/id6759294927?l=en-GB"
              target="_blank" class="download-button" @click="handleDownloadClick">
              <svg class="apple-icon" width="20" height="20" viewBox="0 0 814 1000" fill="currentColor">
                <path
                  d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" />
              </svg>
              前往 App Store 下載
            </a>
          </div>
        </div>
      </div>
    </transition>

    <AppTransition v-if="isStarting" @transition-complete="onTransitionComplete" />
    <header class="main-header" :style="headerStyles">
      <div class="header-content">
        <div class="header-left">
          <img class="header-logo" alt="Logo" src="./assets/app-icon.png" @click="goHome">
        </div>
        <div class="header-center">
          <h1 class="header-title">港式台牌計番神器</h1>
        </div>
        <div class="header-right">
          <div v-if="!isWeb" class="auth-box">
            <div v-if="state.isSignedIn" class="user-avatar" @click="goToSettings">
              <span class="user-initial">{{ userInitial }}</span>
            </div>
            <button v-else class="header-signin-btn" @click="goToSettings">
              登入
            </button>
          </div>
        </div>
      </div>
    </header>

    <div v-if="isWeb && $route.path === '/'" class="web-platform-notice">
      <div class="notice-content">
        <div class="app-store-download">
          <span class="icon">📱</span>
          <span class="download-text">立即下載 iOS App：</span>
          <a href="https://apps.apple.com/hk/app/%E6%B8%AF%E5%BC%8F%E5%8F%B0%E7%89%8C%E8%A8%88%E7%95%AA%E7%A5%9E%E5%99%A8/id6759294927?l=en-GB"
            target="_blank" class="app-store-link">
            <svg class="apple-logo" width="14" height="14" viewBox="0 0 814 1000" fill="currentColor">
              <path
                d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" />
            </svg>
            App Store
          </a>
        </div>
        <div class="refresh-warning">
          <span class="icon">⚠️</span> 警告：重新整理網頁會導致新增規則消失。（App版唔會的）
        </div>
        <div class="support-cta">
          <span class="icon">☕</span> 支持我哋：<a href="https://buymeacoffee.com/siuheibo" target="_blank">Support our
            project (Buy Me a Coffee)</a>
        </div>
      </div>
    </div>

    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { state } from './assets/scores.js'
import { Capacitor } from '@capacitor/core'
import AdMobService from './services/AdMobService'
import AppTransition from './components/AppStartTransition.vue'

export default {
  name: 'App',
  components: {
    AppTransition
  },
  data() {
    const isWeb = Capacitor.getPlatform() === 'web'
    return {
      state,
      isWeb,
      bannerHeight: 0,
      isStarting: !isWeb,
      showAppStoreModal: false
    }
  },
  async mounted() {
    // Show modal on every visit for web users
    if (this.isWeb) {
      // Show modal after a short delay for better UX
      setTimeout(() => {
        this.showAppStoreModal = true
      }, 800)
    }

    if (!this.isWeb) {
      if (!this.isStarting) {
        await this.initAds()
      }

      // Handle Deep Links
      const { App } = await import('@capacitor/app')
      App.addListener('appUrlOpen', data => {
        const url = new URL(data.url)
        console.log('App opened with URL:', url.href)

        // Check if it's a share link
        if (url.pathname.startsWith('/share/')) {
          const token = url.pathname.split('/share/')[1]
          if (token) {
            this.$router.push(`/share/${token}`)
          }
        }
      })

      // Check for deep link on cold start
      const launchUrl = await App.getLaunchUrl()
      if (launchUrl && launchUrl.url) {
        const url = new URL(launchUrl.url)
        if (url.pathname.startsWith('/share/')) {
          const token = url.pathname.split('/share/')[1]
          if (token) {
            this.$router.push(`/share/${token}`)
          }
        }
      }
    }
  },
  async beforeUnmount() {
    if (!this.isWeb) {
      await AdMobService.removeBanner()
      await AdMobService.removeAllListeners()
    }
  },
  computed: {
    userInitial() {
      if (this.state.user && this.state.user.email) {
        return this.state.user.email.charAt(0).toUpperCase()
      }
      return '👤'
    },
    wrapperStyles() {
      // If banner is present, pad for both banner and notch. 
      // If not, let the header handle the notch with its internal padding.
      return {
        paddingTop: this.bannerHeight > 0
          ? `calc(${this.bannerHeight}px + env(safe-area-inset-top))`
          : '0'
      }
    },
    headerStyles() {
      if (this.bannerHeight > 0) {
        return {
          top: `calc(${this.bannerHeight}px + env(safe-area-inset-top))`,
          paddingTop: '0',
          '--banner-height': `${this.bannerHeight}px`
        }
      } else {
        return {
          top: '0',
          paddingTop: 'env(safe-area-inset-top)',
          '--banner-height': '0px'
        }
      }
    }
  },
  methods: {
    closeAppStoreModal() {
      this.showAppStoreModal = false
    },
    handleDownloadClick() {
      // Track the download click and close modal
      this.closeAppStoreModal()
    },
    async onTransitionComplete() {
      this.isStarting = false
      if (!this.isWeb) {
        await this.initAds()
      }
    },
    async initAds() {
      AdMobService.setBannerHeightListener((height) => {
        this.bannerHeight = height
      })
      await AdMobService.initialize()
      this.bannerHeight = await AdMobService.showBanner()
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    goToSettings() {
      if (this.$route.path !== '/settings') {
        this.$router.push('/settings')
      }
    }
  }
}
</script>

<style>
:root {
  --primary-color: #4CAF50;
  --bg-gray: #f0f2f5;
}

body {
  margin: 0;
  background-color: white;
}

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app-wrapper {
  max-width: 820px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-container {
  background: white;
  border-radius: 24px;
  max-width: 440px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #f5f5f5;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 1;
}

.modal-close:hover {
  background: #e0e0e0;
  color: #333;
  transform: rotate(90deg);
}

.modal-content {
  padding: 40px 30px 35px;
  text-align: center;
}

.modal-icon {
  font-size: 64px;
  margin-bottom: 20px;
  animation: bounce 2s infinite;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 12px 0;
}

.modal-description {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 28px 0;
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
}

.download-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.download-button:active {
  transform: translateY(0);
}

.apple-icon {
  flex-shrink: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(30px) scale(0.95);
  opacity: 0;
}

@media (max-width: 600px) {
  .modal-content {
    padding: 35px 25px 30px;
  }

  .modal-icon {
    font-size: 56px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-description {
    font-size: 14px;
  }

  .download-button {
    padding: 14px 20px;
    font-size: 15px;
  }
}

.main-header {
  position: sticky;
  z-index: 1000;
  background: white;
  border-bottom: 1px solid #eee;
  /* top and padding-top are handled via Vue :style for banner dynamics */
}

/* Cover the area above the header (banner and/or safe area) with white when scrolling */
.main-header::before {
  content: '';
  position: absolute;
  top: -100vh;
  left: 0;
  right: 0;
  height: 100vh;
  background: white;
  z-index: -1;
  pointer-events: none;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  height: 60px;
}

.header-left,
.header-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.header-right {
  justify-content: flex-end;
}

.header-center {
  flex: 2;
  text-align: center;
}

.header-logo {
  height: 40px;
  width: auto;
  cursor: pointer;
  transition: transform 0.2s;
}

.header-logo:hover {
  transform: scale(1.05);
}

.header-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: #2d3748;
}

.header-signin-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.2);
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: #f0f0f0;
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #eee;
}

.main-content {
  flex: 1;
  padding-bottom: env(safe-area-inset-bottom);
}

@media (max-width: 480px) {
  .header-title {
    font-size: 0.95rem;
  }

  .header-content {
    padding: 0 10px;
  }
}

.web-platform-notice {
  background: linear-gradient(135deg, #fffcf0 0%, #fff8e1 100%);
  border-bottom: 2px solid #ffd54f;
  padding: 12px 20px;
  animation: fadeInDown 0.5s ease-out;
}

.notice-content {
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.app-store-download {
  color: #1565c0;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.download-text {
  color: #1565c0;
}

.app-store-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: #1565c0;
  padding: 4px 14px;
  border-radius: 16px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.2);
  transition: all 0.2s;
  border: 1px solid rgba(21, 101, 192, 0.2);
}

.app-store-link:hover {
  background: #1565c0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(21, 101, 192, 0.3);
}

.apple-logo {
  flex-shrink: 0;
}

.refresh-warning {
  color: #795548;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.9;
}

.web-platform-notice .icon {
  font-size: 1.1rem;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .web-platform-notice {
    padding: 10px 15px;
  }

  .app-store-download {
    font-size: 0.85rem;
  }

  .app-store-link {
    font-size: 0.8rem;
    padding: 3px 12px;
  }

  .refresh-warning {
    font-size: 0.75rem;
  }
}

.support-cta {
  color: #5d4037;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dotted rgba(121, 85, 72, 0.2);
}

.support-cta a {
  color: #ff8100;
  text-decoration: none;
  font-weight: 700;
  background: white;
  padding: 2px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(255, 129, 0, 0.2);
  transition: all 0.2s;
  font-size: 0.85rem;
}

.support-cta a:hover {
  background: #ff8100;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 129, 0, 0.3);
}

@media (max-width: 480px) {
  .support-cta {
    font-size: 0.8rem;
  }

  .support-cta a {
    font-size: 0.75rem;
    padding: 2px 8px;
  }
}
</style>